export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search for courses and categories"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Without category"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The school has no available courses yet"])}
        }
      },
      "ru": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск по курсам и категориям"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Без категории"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пока у школы нет доступных курсов"])}
        }
      },
      "es": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar cursos y categorías"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sin categoría"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por el momento la escuela no tiene cursos disponibles"])}
        }
      },
      "kk": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курстар мен санаттар бойынша іздеу"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Санатсыз"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мектепте қолжетімді курстар жоқ"])}
        }
      },
      "uz": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurslar va kategoriyalar bo'yicha qidirish"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategoriya yo‘q"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hozircha maktabda mavjud kurslar yo‘q"])}
        }
      },
      "de": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche nach Kursen und Kategorien"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ohne Kategorie"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Derzeit sind keine Kurse verfügbar"])}
        }
      },
      "fr": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recherche de cours et de catégories"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sans catégorie"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a actuellement aucun cours disponible à l'école"])}
        }
      },
      "it": {
        "placeholders": {
          "searchCourses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca per corsi e categorie"])}
        },
        "titles": {
          "withoutCategory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senza categoria"])}
        },
        "messages": {
          "noCoursesAvailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Al momento la scuola non ha corsi disponibili"])}
        }
      }
    }
  })
}
